const getUserInfo = state => state?.userProfileReducer;

export const selectLoggedInUserInfo = (state) => getUserInfo(state)?.loggedInUserInfo;
export const selectLoggedInUserCompany = (state) => getUserInfo(state)?.loggedInUserCompany;
export const selectSwitchableAccounts = (state) => getUserInfo(state)?.switchableAccounts;
